import { useState, useRef, useEffect } from 'react';
import { categories } from '@/mocks/categories';

export default function CategoryDropdown() {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedLabel, setSelectedLabel] = useState('Browse Categories');
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSelect = (name: string, url: string) => {
    setSelectedLabel(name);
    setIsOpen(false);
    window.open(url, '_blank', 'noopener,nofollow');
  };

  return (
    <section className="py-12 md:py-16 bg-background-50" id="categories">
      <div className="max-w-2xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
          Explore Product Categories
        </h2>
        <p className="text-sm md:text-base text-foreground-600 mb-8">
          Select a category below to browse curated product finds on the Sugargoo Spreadsheet
        </p>

        <div className="relative" ref={dropdownRef}>
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="w-full flex items-center justify-between px-6 py-4 rounded-2xl bg-background-100 border-2 border-background-200 hover:border-primary-300 transition-all duration-200 cursor-pointer group"
          >
            <span className="text-base font-medium text-foreground-800">{selectedLabel}</span>
            <i
              className={`ri-arrow-down-s-line text-xl text-foreground-500 transition-transform duration-300 ${
                isOpen ? 'rotate-180' : ''
              }`}
            ></i>
          </button>

          {isOpen && (
            <div className="absolute top-full left-0 right-0 mt-2 bg-background-50 border border-background-200/70 rounded-2xl shadow-lg overflow-hidden z-40 max-h-[360px] overflow-y-auto">
              {categories.map((cat) => (
                <button
                  key={cat.slug}
                  onClick={() => handleSelect(cat.name, cat.url)}
                  className="w-full flex items-center justify-between px-6 py-3.5 text-left hover:bg-background-100 transition-colors duration-150 cursor-pointer border-b border-background-100 last:border-b-0"
                >
                  <span className="text-sm font-medium text-foreground-800">{cat.name}</span>
                  <i className="ri-external-link-line text-foreground-400 text-sm"></i>
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}